import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {NgIconsModule} from '@ng-icons/core';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-info',
  imports: [ CommonModule, NgIconsModule, TranslateModule ],
  templateUrl: './info.component.html'
})
export class InfoComponent {
  @Input() type?: 'success' | 'error' | 'warning' | 'info' | 'default' | 'none' = 'default'; // Solo acepta estos valores
  @Input() title!: string; // Título del componente
  @Input() subtitle?: string;
  @Input() textContent?: string;;

  get iconName(): string {
    switch (this.type) {
      case 'success': return 'tablerCheck';
      case 'warning': return 'tablerAlertTriangle';
      case 'error': return 'tablerX';
      case 'info':
      case 'default':
      default: return 'tablerInfoCircle';
    }
  }

}
